"use strict";

/*!
 * Скрипт виджета курсов хеджа в левой колонке
 */

(function ($) {
  // ECMA5 strict mode
  'use strict';

  // check namespace
  $.b2b = $.b2b || {};
  var defaultOptions = {
    delay: 60,
    rate: '',
    rateId: '',
    userId: 0,
    refreshTime: null,
    synced: true,
    widget: '.hedge-rate',
    tooltip: '#hedge-rate-tooltip',
    errorImg: '.hedge-rate-error',
    useRateInsideButton: false
  };
  var interval;
  var isError = false;

  // ReSharper disable once InconsistentNaming
  var HedgeRateWidget = function HedgeRateWidget() {
    var me;
    var options;
    var btn = {};
    var btns = {};
    function initToolTip() {
      $(options.tooltip).popover({
        placement: 'right',
        content: '<div>По данному курсу Вы можете запросить хеджирование по счету из списка счетов, либо из конкретного счета (доступно для счетов от 10 000<i class="fa fa-usd"></i> до 100 000<i class="fa fa-usd"></i>).</div><div>Данный курс ориентировочный и время его действия ограничено. Окончательный курс хеджирования будет известен после согласования сделки. Время московское.</div>',
        trigger: 'hover',
        html: true
      });
      $(options.errorImg).popover({
        placement: 'right',
        content: 'Произошла ошибка при получении курса. Пожалуйста, обратитесь в службу поддержки.',
        trigger: 'hover',
        container: 'body'
      });
    }
    function refreshWidgetData() {
      me.find('span.hedge-rate-data').html(options.rate);
      initToolTip();
    }
    function refreshTime() {
      var timeBlock = me.find('span.hedge-rate-time');
      if (options.refreshTime !== null) {
        timeBlock.html('(курс будет обновлен через ' + options.refreshTime + ' секунд)');
      } else {
        timeBlock.html('');
      }
    }
    function calcDiff(date) {
      return Math.round(options.delay - (new Date() - new Date(date)) / 1000);
    }
    function error() {
      isError = true;
      clearInterval(interval);
      if (btns !== undefined && btns !== null && btns.length) {
        btns.prop('disabled', 'disabled');
      }
      options.rate = '';
      options.refreshTime = null;
      $(options.errorImg).removeClass('hidden');
      $(options.tooltip).addClass('hidden');
      $('span.hedge-rate-data').addClass('hidden');
      if (options.useRateInsideButton) {
        btns.html(btns.html().replace('(', '').replace(')', ''));
      }
      refreshWidgetData();
      refreshTime();
    }
    function refresh() {
      options.synced = false;
      $.b2b.ajax({
        url: options.refreshUrl,
        success: function success(data) {
          if (data !== undefined && data !== null) {
            options.synced = true;
            options.rateId = data.Id;
            options.rate = (data.Value + '').replace('.', ',');
            options.refreshTime = calcDiff(data.DateReceived);
            refreshWidgetData();
          }
        },
        internalError: function internalError(jqXhr) {
          error();
          $.b2b.errors.showAjaxError(jqXhr);
        }
      });
    }
    ;
    function tick() {
      if (options.synced) {
        if (options.refreshTime <= 0) {
          refresh();
        } else {
          options.refreshTime--;
          refreshTime();
        }
      }
    }
    this.option = function (name, value) {
      if (name) {
        if (!value) {
          return options[name];
        }
        options[name] = value;
      }
    };
    this.refreshRate = function () {
      refresh();
    };
    this.refresh = function (createFnc) {
      if (options !== undefined && options !== null) {
        me = $(options.widget);
        btns = me.find('span.hedge-rate-btn').html('').append(btn).children();
        btns.removeProp('disabled');
        if (btns.attr('disabled')) {
          btns.removeAttr('disabled');
        }
        if (createFnc !== undefined && createFnc !== null) {
          btns.on('click', createFnc);
        }
        refreshWidgetData();
        refreshTime();
      }
    };
    this.create = function (billNumbers) {
      if (!isError) {
        btns.prop('disabled', 'disabled');
        $.b2b.ajax({
          type: 'POST',
          url: options.createUrl,
          data: {
            billNumbers: billNumbers,
            rateId: options.rateId
          },
          success: function success(data) {
            btns.removeProp('disabled');
            $.b2b.toastNotificationService.showSuccess('Запрос на хеджирование отправлен. С Вами свяжется ваш менеджер!', {
              timeout: 10000
            });
          },
          internalError: function internalError(jqXhr) {
            btns.removeProp('disabled');
            $.b2b.errors.showAjaxError(jqXhr);
          }
        });
      }
    };
    this.init = function (opt) {
      options = $.extend({}, defaultOptions, opt);
      me = $(options.widget);
      btn = $('<button class="btn btn-default btn-xs">Хеджировать' + (options.useRateInsideButton ? ' (<span class="hedge-rate-data"></span>) <a href="#" id="hedge-rate-tooltip" class="x-icon x-icon-question"></a></span>' : '') + ' <i class="x-icon x-icon-exclamation hidden hedge-rate-error"></i></button>').prop('disabled', 'disabled');
      if (options.userId > 0) {
        refresh();
        initToolTip();
        interval = setInterval(tick, 1000);
      }
    };
    this.clear = function () {
      if (interval) {
        clearInterval(interval);
      }
    };
  };
  $.b2b.hedgeRateWidget = new HedgeRateWidget();
})(jQuery);